import { render } from "./ShiftDetails.vue?vue&type=template&id=46a40231&scoped=true"
import script from "./ShiftDetails.vue?vue&type=script&lang=js"
export * from "./ShiftDetails.vue?vue&type=script&lang=js"

import "./ShiftDetails.vue?vue&type=style&index=0&id=46a40231&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a40231"]])

export default __exports__